export default __webpack_public_path__ + "static/media/qrcode.c4eebc03.jpg";